/**
 * Buffers.ts — small helpers around GPUBuffer creation/upload.
 */

export function createBufferFromBytes(
  device: GPUDevice,
  bytes: Uint8Array,
  usage: GPUBufferUsageFlags,
  label?: string,
): GPUBuffer {
  const buffer = device.createBuffer({
    label,
    size: alignTo(bytes.byteLength, 4),
    usage,
    mappedAtCreation: true,
  });
  new Uint8Array(buffer.getMappedRange()).set(bytes);
  buffer.unmap();
  return buffer;
}

export function createBufferFromTypedArray(
  device: GPUDevice,
  data: Float32Array | Uint32Array | Uint16Array | Int32Array,
  usage: GPUBufferUsageFlags,
  label?: string,
): GPUBuffer {
  const bytes = new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
  return createBufferFromBytes(device, bytes, usage, label);
}

export function createUniformBuffer(
  device: GPUDevice,
  byteSize: number,
  label?: string,
): GPUBuffer {
  return device.createBuffer({
    label,
    size: alignTo(byteSize, 16),
    usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
  });
}

export function alignTo(value: number, alignment: number): number {
  return Math.ceil(value / alignment) * alignment;
}
